/*                                    页面权限                                 */
/* -------------------------------------------------------------------------- */

// 会员认证列表页面
export const MEMBER_AUTHENTICATION_PAGE = '6c05c5a7-f868-4fb7-8274-e0fc5a986bed'

// 未分配的会员 tab
export const MEMBER_UNASSIGNED_TAB = 'efa47ca9-4611-4fbf-a927-476aa4d0b415'

// 认证页面查看权限
export const MEMBER_AUTHENTICATION_DETIAL_PAGE =
  '107abce3-03f7-427b-a717-f6b8f771942b'

/* -------------------------------------------------------------------------- */
/*                                    操作权限                                 */
/* -------------------------------------------------------------------------- */

// 分配跟进人员
export const ASSIGN_FOLLOWER_ACTION = '1332a2c8-5ddf-4258-ba7a-d0a8d47b11c3'
